import React from 'react'
import './NewDone.css';
import { useParams } from 'react-router';
import { useState, useEffect } from 'react';
import fetchData from '../../function/fetchData';
import { GoogleMap, MarkerF, useLoadScript } from '@react-google-maps/api';
import {containerStyle, options} from './mapAssets/mapAssets'
import InfoAboutDriver from '../../components/InfoAboutDriver'
import checkDateTime from '../../function/checkDateTime';
import CancelOrderButton from '../../components/CancelOrderButton'
import Loading2 from '../../components/Loading2'
import dateTimeDiference from '../../function/dateTimeDiference'
import dateTimeDiferenceBetween from '../../function/dateTimeDiferenceBetween'
import CountDownCyrcleTimer from '../../components/CountDownCyrcleTimer';
import StatusShowInfo from '../../components/StatusShowInfo';
import InfoAboutTrip from '../../components/InfoAboutTrip'


//ICO
import iconTel from '../../img/tel.png'
import iconCustomer from '../../img/customer.png'
import iconDestination from '../../img/destination.png'
import iconTaxi from '../../img/taxi.png'

// logos
import logoMarco from '../../img/logoMarco.png'
import logoAbcnet from '../../img/logoAbcnet.png'

//SERVER ADRES
const server = process.env.REACT_APP_SERVER_ADRES;
const adresOfServer = server +"api2/infoAboutTrip.php";
const cancelAdres = server +"api2/cancelOrder.php";

const places = ["places"];
let alertOne = false;
let status = 0

//***** MAIN APP *****//
const Done = () => {
    const [loading, setLoading] = useState(false)
    const [tokenOfClient, setTokenOfClient] = useState()
  
    // Kontrola tokenu
    useEffect(() => {
        // Načtení hodnoty z localStorage po načtení komponenty
        const token = localStorage.getItem('token');

        if (token) {
            setTokenOfClient(token)
        }
        }, []); // Prázdné pole závislostí znamená, že se tento useEffect spustí jednou po načtení komponenty


   
   
    // MAPA
    const [onTheMap , setOnTheMap] = useState({
        startGps: {lat: null,lng: null},
        destGps: {lat: null,lng: null},
        driverGps: {lat: null,lng: null},
        mapZoom: 13,
        centerPositionOnMap: {lat:50.46017587548713, lng: 13.41622507444904},
        places: ["places"],
    })
    // DRIVER
    const [infoAboutDriver, setInfoAboutDriver] = useState({
        id: null,
        nick: "",
        tel: "",
        status: "",
        type: "",
        spz: "",
    }) 
    // TRIP
    const [infoAboutTrip, setInfoAboutTrip] = useState({
        price: 0,
        distance: 0,
        timeToTake: 0,
        status: 0,
        startAdres: null,
        destAdres: null,
        bookTime: null,
    })
    const [dataOk, setDataOk] = useState(false)

    //TOKEN FROM GET
    const {tokenOfTrip} = useParams()

    // Zjistí zda už nebyl spuštěn odpočet (pokud již jednou byl, znova neukáže)
    const savedTimeInLocalStor = localStorage.getItem(tokenOfTrip);

    // Rozdíl mezi časem vložení a aktuálním časem v minutách
    const dateTimeDiferenceResult = dateTimeDiference(infoAboutTrip.dateTime)

    // Zobrazí jen čas do kdy dorazí
    const onlyTime = (dateTime) => {
        let onlyTime = dateTime.split(" ");
        let withoutSec = onlyTime[1].split(":")
        return withoutSec[0]+ ":" +withoutSec[1]
        }
    // MAP INIT
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY,
        libraries: places,
        })

    // Získá data o objednávce
    useEffect( ()=> {
        const fetchDataFunction = () =>{
         
            fetchData(adresOfServer, {"tokenOfTrip": tokenOfTrip})
            .then( (res) =>{
              
                const statusOfOrder = parseInt(res.trip.status)
                // Zajistí aby se rendrovalo pouze , pokud je jiný status
                if(status !== statusOfOrder){
                    status = statusOfOrder
                    

                    // TOKEN nenašel
                    if(res.info === "wrongToken" ){
                        window.location.href = "/" 
                        return
                    }
                    // Token našel ale jízda už je hotova
                    if(statusOfOrder === 5 ){
                        window.location.href = "/end/" + tokenOfTrip
                        return
                    }

                    if(statusOfOrder === 6 ){
                        alert("Marco_Taxi se musí omluvit, ale nestíhá, nechceme aby jste dlouho čekali na náš vůz a tak rušíme objednávku. Děkujeme za pochopení.")
                        window.location.href = "/"
                        return
                    }
                    if(statusOfOrder === 10){
                        alert("Z důvodu porušení závazné objednávky, Vám rušíme účet u naší společnosti. Mějte pěkný den. Marco_Taxi")
                    }
                    // Řidič přehodil jízdu na externí partnery
                    if(statusOfOrder === 12 ){
                        window.location.href = "/external/" + infoAboutTrip.startAdres + "/" + infoAboutTrip.destAdres + "/" + tokenOfClient
                        return
                    }

                    // Zazoomuje mapu, řidič je blízko
                    if(statusOfOrder === 3 ){
                        setOnTheMap({
                            ...onTheMap, 
                            startGps: {lat: parseFloat(res.trip.latitude),lng: parseFloat(res.trip.longitude)},
                            destGps: {lat: parseFloat(res.trip.desLat), lng: parseFloat(res.trip.desLng)},
                            driverGps: {lat: parseFloat(res.infoAboutDriver.latitude) ,lng: parseFloat(res.infoAboutDriver.longitude)},
                            mapZoom: 15,
                            centerPositionOnMap: {lat: parseFloat(res.infoAboutDriver.latitude) ,lng: parseFloat(res.infoAboutDriver.longitude)}
                        })
                    } else {
                        // Pozice pro mapu
                        setOnTheMap({...onTheMap,
                            startGps: {lat: parseFloat(res.trip.latitude),lng: parseFloat(res.trip.longitude)},
                            destGps: {lat: parseFloat(res.trip.desLat), lng: parseFloat(res.trip.desLng)},
                            driverGps: {lat: parseFloat(res.infoAboutDriver.latitude) ,lng: parseFloat(res.infoAboutDriver.longitude)},
          
                        })
                    }
                }


                    // Info o řidiči
                    setInfoAboutDriver({
                        id: res.infoAboutDriver.id,
                        nick: res.infoAboutDriver.nick,
                        tel: res.infoAboutDriver.tel,
                        status: res.infoAboutDriver.status,
                        type: res.infoAboutDriver.type,
                        spz: res.infoAboutDriver.spz,
                    })
                    // Info o jízdě
                    setInfoAboutTrip({
                        price: res.price,
                        distance: parseInt(res.trip.tripDistance),
                        timeToTake: res.trip.destinationTime,
                        status: parseInt(res.trip.status),
                        dateTime: res.trip.date,
                        startAdres: res.trip.start,
                        destAdres: res.trip.destination,
                        dateOfChage: res.trip.dateOfChage,
                        bookTime: res.trip.bookTime
                    })

                    setDataOk(true)
                
                })
        } 
        // První spuštění
        fetchDataFunction();
        // Poté pravidelné
        const intervalId = setInterval(fetchDataFunction, 5000);

        // Když se komponenta odpojí, vyčistíme interval
        return () => clearInterval(intervalId);
    }, [infoAboutTrip.status])

    // Storno tlačítko (do 2 min)
    const onHandleStornoOrder = () => {
        setLoading(true)
        alert("Na Vaší žádost jsme zrušili objednávku")
        fetchData(cancelAdres, {tokenOfTrip: tokenOfTrip})
            .then( (res) => {
                setLoading(false)
                if(res.info === "change"){
                    window.location.href = "/" 
                    return
                } else if(res.info === "late"){
                    alert("Pro storno je již pozdě");
                } else {
                    alert("chyba serveru")
                }
            })
    }

    let priceOfOrder = ""
    let timeToTake = ""
    

    // kolik uplynulo času od poslední změny
    const timeBetweenLastUpdate = dateTimeDiferenceBetween(    infoAboutTrip.dateOfChage , infoAboutTrip.timeToTake) 
    const timeTillEnd = dateTimeDiference(infoAboutTrip.timeToTake)

    if(!isLoaded){
        return(
            <Loading2 />
        )
    } 

    return (
        <div className='orderContainerDone'>
     
            {loading && <Loading2 /> }
            {savedTimeInLocalStor !== "done" && dateTimeDiferenceResult <=2  ?  <CancelOrderButton tokenOfTrip={tokenOfTrip} onHandleStornoOrder={onHandleStornoOrder}/> : ""}
            <section className='mapContentDone'>
           
                <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={onTheMap.centerPositionOnMap}
                        zoom={onTheMap.mapZoom}
                        options={options}
                > 
                {dataOk && 
                    <MarkerF 
                        position={onTheMap.startGps} 
                        icon={{url: iconCustomer, scaledSize: new window.google.maps.Size(70, 70)}}
                    />
                }
                {dataOk && 
                    <MarkerF 
                        position={onTheMap.destGps} 
                        icon={{url: iconDestination, scaledSize: new window.google.maps.Size(70, 70)}}
                    />
                }
                {infoAboutTrip.status === 3 && 
                    <MarkerF 
                        position={onTheMap.driverGps} 
                        icon={{url: iconTaxi, scaledSize: new window.google.maps.Size(70, 70)}}
                    />
                }
                 

                </GoogleMap>

            </section>
            {/****** Information ******/}
            {dataOk && 
            <>
            {infoAboutTrip?.timeToTake && infoAboutTrip.status <= 2 && <CountDownCyrcleTimer timeBetweenLastUpdate={timeBetweenLastUpdate} timeTillEnd={timeTillEnd}   />}
            {infoAboutTrip?.timeToTake && infoAboutTrip.status > 2 &&  <StatusShowInfo infoAboutDriver={infoAboutDriver} /> }
            <section className='bottomInfo'>
                {infoAboutTrip.status >= 2 &&
                <a className="orderTelContainer" href={'tel:'+infoAboutDriver.tel}>
                    <img className='icontel' src={iconTel} />      
                </a>
                }
                <div className='google'>
                    Google
                </div>
                <h3>Aktuální status</h3>
                <br />
                <InfoAboutTrip InfoAboutTrip={infoAboutTrip}/>
              
                
            </section>
            </>
            }
            
        </div>
    )
}

export default Done
